<template>
    <a-card size="small" title="回调应用管理">
        <a-button type="primary" slot="extra" @click="handleShow()">新建</a-button>
        <searchE @handleSearch="getAppSumData"></searchE>
        <!-- 系统列表 -->
        <a-table id="myServiceTable" :columns="columns" :data-source="tableData" :scroll="{ x: clientWidth}"
            :pagination="false" :loading="tloading" rowKey="processor">
  
            <template slot="operation" slot-scope="text, record">
                <a-button type="link" @click="handleTopic(record)">主题管理</a-button>
                <a-button type="link" @click="handleShow(record)">编辑</a-button>
                <a-popconfirm title="确认删除?" @confirm="() => handleDelete(record)">
                    <a class="tableLink"  href="javascript:;">删除</a>
                </a-popconfirm>
            </template>
        </a-table>
        <a-pagination v-model="pagination.page" :total="pagination.total" :pageSize="pagination.pageSize"
            @change="handlePageChange" show-less-items style="float: right; margin-top: 20px" />

        <a-modal :title="modalTitle" :visible="isShow" :confirm-loading="confirmLoading" width="450px"
            @cancel="handleCancel">
            <a-form-model layout="inline" :model="configItem" ref="ruleForm" :rules="rules" >
                <a-form-model-item label="回调应用编码" ref="processor"  prop="processor">
                    <a-input style="width:200px;" v-model="configItem.processor" placeholder="回调应用编码" allow-clear></a-input>
                </a-form-model-item>
                <a-form-model-item label="回调应用名称" ref="processorname"  prop="processorname">
                    <a-input style="width:200px;" v-model="configItem.processorname" placeholder="回调应用名称" allow-clear></a-input>
                </a-form-model-item>
                <!-- 0-无  1-绑定商户  2-绑定服务商  3-绑定商圈 -->
                <a-form-model-item label="回调绑定类型" ref="bindtype"  prop="bindtype">
                    <a-select v-model="configItem.bindtype" style="width:200px;">
                        <a-select-option value="0">
                        无
                        </a-select-option>
                        <a-select-option value="1">
                        绑定商户
                        </a-select-option>
                        <a-select-option value="2">
                        绑定服务商
                        </a-select-option>
                        <a-select-option value="3">
                        绑定商圈
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item label="回调应用版本" ref="version"  prop="version">
                    <a-select v-model="configItem.version" style="width:200px;">
                        <a-select-option value="V3.0">
                        V3.0
                        </a-select-option>
                        <a-select-option value="V5.0">
                        V5.0
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
            </a-form-model>
            <template slot="footer">
                <a-button key="back" @click="handleCancel">
                取消
                </a-button>
                <a-button key="submit" type="primary" :loading="confirmLoading" @click="handleSave">
                确定
                </a-button>
            </template>
                
        </a-modal>

        <topics ref="topicsID"></topics>


    </a-card>
</template>
<script>
import searchE from './search'
import topics from './topics.vue'
let pagination={
    total:0,
    pageSize:0,
    page:1,
}
// <!-- 0-无  1-绑定商户  2-绑定服务商  3-绑定商圈 -->
let typeNums = {
    '0':'无',
    '1':'绑定商户',
    '2':'绑定服务商',
    '3':'绑定商圈'
}

const columns = [
    {
        title: "序号",
        width: 80,
        align: "center",
        customRender: (text, record, index) => {
            let { page, pageSize } = pagination;
            return (Number(page) - 1) * Number(pageSize) + index + 1;
        }
    },
    {
        title: "回调应用编码",
        width: 100,
        dataIndex: "processor",
        align: "center",
        ellipsises: true,
    },
    {
        title: "回调应用名称",
        width: 200,
        dataIndex: "processorname",
        align: "center",
        ellipsises: true,
    },
    
    {
        title: "回调绑定类型",
        width:100,
        dataIndex: "bindtype",
        customRender: (text) => {
            return typeNums[text];
        },
        align: "center",
    },

    {
        title: "版本",
        width:80,
        dataIndex: "version",
        align: "center",
    },
    // {
    //     title: "创建时间",
    //     width: 150,
    //     dataIndex: "createtime",
    //     ellipsis: true,
    //     align: "center",
    // },
    
    // {
    //     title: "更新时间",
    //     width: 150,
    //     dataIndex: "updatetime",
    //     ellipsis: true,
    //     align: "center",
    // },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 180,
        scopedSlots: { customRender: 'operation' },
    }

    

];

export default {
    data () {
        return {
            modalTitle:'',
            isShow:false,
            confirmLoading:false,
            rules: {
                processorname: [
                    { required: true, message: ' 请输入 ', trigger: 'blur' },
                ],
                processor: [
                    { required: true, message: ' 请输入 ', trigger: 'blur' },
                ],
                bindtype: [
                    { required: true, message: ' 请输入 ', trigger: 'blur' },
                ],
                version: [
                    { required: true, message: ' 请输入 ', trigger: 'blur' },
                ],
            },
            configItem:{
                id:'',
                processor:'',
                processorname:'',
                bindtype:'0',
                version:'V5.0'
            },
            columns,
            tableData:[],
            tloading:false,
            clientWidth:800,
            searchP:{},
            pagination,
            modalVisible:false,
        }
    },
    methods: {
        handleTopic(record){
            this.$refs.topicsID.init(record.processor,record.processorname)
        },
        handlePageChange(v) {
            this.pagination.page = v;
            this.getAppSumData();
        },
        getAppSumData(sp){
            let that = this
            if(sp){
                that.searchP = sp;
            }
            let params = {
                ...that.searchP,
                ...that.pagination,
                urlparams:false
            };
            that.$store.dispatch({
                type: 'open/callbackAppManagePage',
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    that.tableData = result.list;
                    that.pagination.total = parseInt(result.totalRecords);
                    that.pagination.pageSize = parseInt(result.pageSize);
                    that.pagination.page = parseInt(result.page);
                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;

            });
        },
        handleSave(){
            let that = this;
            that.$refs.ruleForm.validate(valid => {
                if (valid) {
                    that.confirmLoading = true;
                    if(that.configItem.id != ''){
                        that.$store
                            .dispatch({
                                type: "open/callbackAppManageEdit",
                                params: that.configItem
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    that.handleCancel();
                                    that.confirmLoading = false;
                                }
                            });
                    }
                    else{
                        //新增
                        that.$store
                            .dispatch({
                                type: "open/callbackAppManageAdd",
                                params: that.configItem
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    that.handleCancel();
                                    that.confirmLoading = false;

                                }
                            });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        handleShow(record){
            this.isShow = true;
            let that = this;
            if(record){
                that.modalTitle = '编辑回调应用'
                that.$store
                    .dispatch({
                        type: "open/callbackAppManageDetail",
                        params: {
                            ...record
                        }
                    })
                    .then((response) => {
                        if(response.data.success == '1'){
                            that.configItem = response.data.data
                        }
                    });
            }
            else{
                this.modalTitle = '新建回调应用'
                this.configItem = {
                    id:'',
                    processor:'',
                    processorname:'',
                    bindtype:'0',
                    version:'V5.0'
                }
            }
        },
        handleDelete(record){
            let that = this;
            that.$store.dispatch({
                type: "open/callbackAppManageDel",
                params: {processor: record.processor}
            }).then((res) => {
                if (res.status == '200') {
                    that.pagination.page = 1;
                    that.getAppSumData()
                }
            });
        },
        handleCancel(){
            this.configItem = {
                processor:'',
                processorname:'',
                bindtype:'0'
            }
            this.isShow = false;
            this.pagination.page = 1;

            this.getAppSumData()
        },
    },
    components:{
        searchE,
        topics
    },
};
</script>

<style scoped>
    .trend_pagination{
        margin-top: 10px;
    }

    .tableLink{
        margin-right: 10px;
    }

</style>
